import { CAS } from '../service/ChatConfig.Service'
import { IChatMessage, IChatMeta, ICreateNewChatPayload, IPaginatedResponse, IPeopleSearchResults, IUser } from '../interfaces'

import { AxiosResponse } from 'axios';

function get<T>(uri: string, params?: any){
    return CAS.ParentHttpClient?.get?.(
        uri,
        params
    ) as Promise<AxiosResponse<T>>
}

function post<T>(uri: string, payload:any, params?: any){
    return CAS.ParentHttpClient?.post?.(
        uri,
        payload,
        params
    ) as Promise<AxiosResponse<T>>
}
 
export function getChats(ifModifiedSince: string, params?: any, signal?:AbortSignal): Promise<AxiosResponse<IPaginatedResponse<IChatMeta[]>>>{
    const uri = 'api/chats';
    
    return get<IPaginatedResponse<IChatMeta[]>>(
        uri,
        {
            headers: { "If-Modified-Since": ifModifiedSince},
            params,
            signal,
            validateStatus: (status:any) => status < 400
        }
    )
}

export function getChatById(id: number): Promise<AxiosResponse<IChatMeta>>{
    const messageUri = `api/chats/${id}`
    

    return get<IChatMeta>(
        messageUri
    )
 
}

export function getChatByUserId(userId: number): Promise<AxiosResponse<IPaginatedResponse<IChatMeta[]>>>{
    const uri = `api/chats`
    
    return get<IPaginatedResponse<IChatMeta[]>>(
        uri,
        {
            params: {
                userIdFilter: userId
            }
        }
    )
}

export function getChatMessagesById(id: number, ifModifiedSince?: string, paginationOptions?: any): Promise<AxiosResponse<IPaginatedResponse<IChatMessage[]>>>{
    const uri = `api/chats/${id}/messages`

    
    return get<IPaginatedResponse<IChatMessage[]>>(
        uri,
        {
            headers: { "If-Modified-Since": ifModifiedSince},
            params: paginationOptions,
            validateStatus: (status:any) => status < 400
        }
    );
}

export function getMyUserProfile(): Promise<AxiosResponse<IUser>> {
    return get<IUser>('api/user/me/profile')
}

export function sendChatMessage(chatId: number, payload: IChatMessage): Promise<AxiosResponse> {
    const messsagePayload = {
        message: {
            body: payload.body,
            sentAt: payload.timestamp,
            id: payload.id
        }
    }

    return post(`api/chats/${chatId}/messages`, messsagePayload)  
}

export function createNewChat(payload:ICreateNewChatPayload): Promise<AxiosResponse> {
    return post('api/chats', payload) 
}

export function getPeopleSearchResults(uri: string, signal?: AbortSignal): Promise<AxiosResponse<IPeopleSearchResults>> {
    return get<IPeopleSearchResults>(uri, { signal });
}
